import MakeTeamLeadModal from './MakeTeamLeadModal';

export default MakeTeamLeadModal;
